import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useParams, useHistory } from "react-router-dom";
import Loader from "../../components/loader";
import api from "../../services/api";

const INFORMATION = "INFORMATION";
const RAW_DATA = "RAW_DATA";

export default function CodeDetail() {
  const [code, setCode] = useState();
  const [tab, setTab] = useState(INFORMATION);
  const { id } = useParams();

  useEffect(() => {
    (async () => {
      try {
        const { ok, data } = await api.get(`/codes/${id}`);
        if (ok) setCode(data);
      } catch (e) {
        toast.error(e.message);
      }
    })();
  }, [id]);

  if (!code) return <Loader />;

  return (
    <div>
      <nav className="flex items-center gap-2 pl-2">
        <button
          className={`${
            tab === INFORMATION ? "bg-black-80 text-white" : ""
          } transition-colors px-3 py-2 text-sm`}
          onClick={() => setTab(INFORMATION)}
        >
          Information
        </button>
        <button
          className={`${
            tab === RAW_DATA ? "bg-black-80 text-white" : ""
          } transition-colors px-3 py-2 text-sm`}
          onClick={() => setTab(RAW_DATA)}
        >
          Raw Data
        </button>
      </nav>
      <div className="bg-white rounded-md p-6 border border-primary-black-50">
        {tab === INFORMATION && <Information code={code} />}
        {tab === RAW_DATA && <RawData code={code} />}
      </div>
    </div>
  );
}

const Information = ({ code }) => {
  const [values, setValues] = useState(code);
  const history = useHistory();

  const onUpdate = async () => {
    const res = await api.put(`/codes/${code.id}`, values);
    if (!res.ok) return toast.error(res.error);
    toast.success("Updated!");
  };

  const onDelete = async () => {
    if (!window.confirm("Are you sure?")) return;
    const res = await api.remove(`/codes/${code.id}`);
    if (!res.ok) return toast.error(res.error);
    toast.success("Deleted!");
    history.push("/code");
  };

  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Code</div>
          <input
            className="input"
            value={values.code || ""}
            onChange={(e) => setValues({ ...values, code: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Discount</div>
          <input
            className="input"
            type="number"
            value={values.discount || ""}
            onChange={(e) => setValues({ ...values, discount: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Role</div>
          <input
            className="input"
            value={values.role || ""}
            onChange={(e) => setValues({ ...values, role: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Group</div>
          <input
            className="input"
            value={values.group || ""}
            onChange={(e) => setValues({ ...values, group: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Description</div>
          <input
            className="input"
            value={values.description || ""}
            onChange={(e) =>
              setValues({ ...values, description: e.target.value })
            }
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Ending Date</div>
          <input
            className="input"
            type="date"
            value={values.endingdate ? values.endingdate.split("T")[0] : ""}
            onChange={(e) =>
              setValues({ ...values, endingdate: e.target.value })
            }
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Ending Time</div>
          <input
            className="input"
            value={values.endingTime || ""}
            onChange={(e) =>
              setValues({ ...values, endingTime: e.target.value })
            }
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Match</div>
          <input
            className="input"
            value={values.match || ""}
            onChange={(e) => setValues({ ...values, match: e.target.value })}
          />
        </div>
      </div>
      <div className="flex items-center space-x-2 mt-4">
        <button className="btn btn-primary" onClick={onUpdate}>
          Update
        </button>
        <button className="btn btn-red" onClick={onDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

const RawData = ({ code }) => {
  return (
    <div className="">
      <pre> {JSON.stringify(code, null, 2)}</pre>
    </div>
  );
};
